import React, { Component } from "react";
import { withRouter } from "react-router";

const HEADERS = ["Name", "Mobile", "Email", "Joined", ""];

export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = { hovered: null };
  }

  formatDate(createdAt) {
    if (!createdAt) return "—";
    const secs = createdAt.seconds || createdAt._seconds;
    if (!secs) return "—";
    return new Date(secs * 1000).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  render() {
    const { myData } = this.props;
    const { hovered } = this.state;

    return (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F8F7FF", borderBottom: "2px solid #EEE" }}>
              {HEADERS.map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "12px 16px",
                    color: "#6C63FF",
                    fontWeight: 600,
                    fontSize: 13,
                    textAlign: i === HEADERS.length - 1 ? "center" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(!myData || myData.length === 0) && (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}
                >
                  No users found
                </td>
              </tr>
            )}
            {(myData || []).map((user) => {
              const isHovered = hovered === user.uid;
              return (
                <tr
                  key={user.uid}
                  style={{
                    borderBottom: "1px solid #F3F3F3",
                    background: isHovered ? "#FAFBFF" : "white",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={() => this.setState({ hovered: user.uid })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                >
                  {/* Name */}
                  <td style={{ padding: "10px 16px", fontSize: 13, fontWeight: 500, color: "#222" }}>
                    {user.displayName || "—"}
                  </td>
                  {/* Mobile */}
                  <td style={{ padding: "10px 16px", fontSize: 13, color: "#555" }}>
                    {user.mobileNo || user.mobileNumber || "—"}
                  </td>
                  {/* Email */}
                  <td style={{ padding: "10px 16px", fontSize: 13, color: "#555" }}>
                    {user.email || "—"}
                  </td>
                  {/* Joined */}
                  <td style={{ padding: "10px 16px", fontSize: 13, color: "#888", whiteSpace: "nowrap" }}>
                    {this.formatDate(user.createdAt)}
                  </td>
                  {/* Action */}
                  <td style={{ padding: "10px 16px", textAlign: "center" }}>
                    <button
                      style={{
                        padding: "5px 16px",
                        borderRadius: 6,
                        border: "1px solid #6C63FF",
                        color: "#6C63FF",
                        background: "white",
                        cursor: "pointer",
                        fontSize: 13,
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                      }}
                      onClick={() =>
                        this.props.history.push(
                          `${process.env.PUBLIC_URL}/users/list-user/${user.uid}`
                        )
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withRouter(Datatable);
